import Pagina from './pagina';
export default Pagina;